import {
  el,
  refreshMetrics,
  revokeResult,
  signalPlanChange,
  state,
} from "./core.js"
import { refreshCropMetrics, updateCropOverlay } from "./crop.js"
import { refreshWorkerControl } from "./workers.js"

let initialized = false

function refreshSmoothLoopUi() {
  const unavailable = state.direction === "rebound"
  const requested = Boolean(el.smoothLoopToggle?.checked)
  if (el.smoothLoopToggleCard) el.smoothLoopToggleCard.classList.toggle("disabled-control", unavailable)
  if (el.smoothLoopFramesCard) el.smoothLoopFramesCard.classList.toggle("disabled-control", unavailable || !requested)
  if (el.smoothLoopFramesSlider) el.smoothLoopFramesSlider.disabled = unavailable || !requested
  if (el.smoothLoopFramesValue && el.smoothLoopFramesSlider) {
    el.smoothLoopFramesValue.textContent = `${el.smoothLoopFramesSlider.value} frames`
  }
  if (el.smoothLoopHelper && unavailable) el.smoothLoopHelper.textContent = "Forward and Reverse only"
}

function smoothLoopChanged(reason) {
  refreshSmoothLoopUi()
  revokeResult(true)
  refreshMetrics()
  refreshCropMetrics()
  refreshWorkerControl()
  signalPlanChange(reason)
}

function syncCropEditorVisibility() {
  const frame = document.getElementById("cropFrame")
  const toolbar = document.getElementById("cropToolbar")
  const bufferedCroppedPreview = state.direction !== "forward" || Boolean(el.videoPreview?.hidden)
  const hide = !state.file || bufferedCroppedPreview
  if (frame) frame.hidden = hide
  if (toolbar) toolbar.hidden = hide
  if (!hide) requestAnimationFrame(updateCropOverlay)
}

export function setupSmoothLoopUi() {
  if (initialized) return
  initialized = true
  el.smoothLoopToggle?.addEventListener("input", () => smoothLoopChanged("smoothLoopToggle"))
  el.smoothLoopToggle?.addEventListener("change", () => smoothLoopChanged("smoothLoopToggle"))
  el.smoothLoopFramesSlider?.addEventListener("input", () => smoothLoopChanged("smoothLoopFrames"))
  el.smoothLoopFramesSlider?.addEventListener("change", () => smoothLoopChanged("smoothLoopFrames"))

  addEventListener("converter-plan-change", () => {
    refreshSmoothLoopUi()
    requestAnimationFrame(syncCropEditorVisibility)
  })
  addEventListener("converter-crop-change", () => requestAnimationFrame(syncCropEditorVisibility))
  addEventListener("resize", () => requestAnimationFrame(syncCropEditorVisibility))

  if (el.videoPreview) {
    new MutationObserver(syncCropEditorVisibility).observe(el.videoPreview, {
      attributes: true,
      attributeFilter: ["hidden", "src"],
    })
    el.videoPreview.addEventListener("loadedmetadata", () => requestAnimationFrame(syncCropEditorVisibility))
  }

  refreshSmoothLoopUi()
  syncCropEditorVisibility()
}
